import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SoundToggle } from "@/components/games/SoundToggle";
import { MusicToggle } from "@/components/games/GameMusic";

export const GameArena = ({ children }) => (
  <div className="relative" data-testid="game-arena">
    <div className="game-aurora" aria-hidden><span /><span /><span /></div>
    <div className="relative z-[1]">{children}</div>
  </div>
);

export function ArenaHeader({ title, sub, icon: Icon, back, testId = "arena-header" }) {
  return (
    <header className="arena-head rounded-[1.75rem] p-4 sm:p-5 flex items-center gap-3 fade-rise" data-testid={testId}>
      {back ? (
        <Link to={back} data-testid="game-detail-back" className="w-11 h-11 rounded-2xl bg-white/80 ring-1 ring-pink-100 flex items-center justify-center hover:bg-white active:scale-95 transition-transform"><ArrowLeft className="w-5 h-5 text-rose-500" /></Link>
      ) : Icon && <span className="arena-icon w-12 h-12 rounded-2xl flex items-center justify-center shrink-0"><Icon className="w-6 h-6 text-white" /></span>}
      <div className="flex-1 min-w-0">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.3em] text-rose-500/80">itzPlay Arena</p>
        <h1 className="font-display text-2xl sm:text-3xl font-black leading-tight line-clamp-2 text-slate-900">{title}</h1>
        {sub && <p className="text-xs sm:text-sm text-slate-500">{sub}</p>}
      </div>
      <div className="flex flex-col sm:flex-row gap-1.5 items-end">
        <MusicToggle compact />
        <SoundToggle compact />
      </div>
    </header>
  );
}
